import { CurrencyDollarIcon } from '@heroicons/react/24/outline';

import { useAppDispatch } from 'src/app/store/hooks';
import type {
  TripRead,
} from 'src/common/external/bambi-api/bambiApi';
import type {
  TripListRead,
} from 'src/common/external/bambi-api/tripsApi';

import { onPriceSummaryModalOpen } from '../pricing.slice';

export function PriceSummaryModalButton({
  trip,
}: {
  trip: TripRead | TripListRead;
}) {
  const dispatch = useAppDispatch();

  return (
    <CurrencyDollarIcon
      data-testid="price-summary-modal-button"
      className="h-6 w-6 hover:cursor-pointer"
      onClick={() => dispatch(onPriceSummaryModalOpen(trip))}
    />
  );
}
